import React, {Component, Fragment,} from 'react';

import {Row} from 'react-materialize';

import SourceMasters from '../../components/applicationComponents/sourceMaster';

class SourceMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <Row>
                    <Fragment>
                        <Row
                            className={this.state.isLoaded ? "card-container" : "card-container loader-wait"}
                        >
                            <SourceMasters history={this.props.history} category={this.props.category}/>
                        </Row>
                    </Fragment>
                </Row>
            </div>
        );
    }
}

export default SourceMaster;
